import { createBrowserRouter, Navigate } from 'react-router-dom'
import { SignInPage } from './pages/SignInPage'
import { CallbackPage } from './pages/CallbackPage'
import { ProfilePage } from './pages/ProfilePage'
import { LogoutPage } from './pages/LogoutPage'
import { DeleteAccountPage } from './pages/DeleteAccountPage'
import { PrivacyPage } from './pages/PrivacyPage'

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/profile" replace /> },
  { path: '/signin', element: <SignInPage /> },
  { path: '/callback', element: <CallbackPage /> },
  { path: '/profile', element: <ProfilePage /> },
  { path: '/logout', element: <LogoutPage /> },
  { path: '/delete-account', element: <DeleteAccountPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
])
